var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modals',{attrs:{"title":'Create New User',"validateBeforeClose":_vm.validateBeforeClose,"display":_vm.display,"parentTag":'form',"novalidate":'novalidate',"fullMobile":true},on:{"show":_vm.closeUserSettingModal},scopedSlots:_vm._u([{key:"modal-content",fn:function(){return [_c('div',{staticClass:"user-info__container"},[_c('UserForm',{attrs:{"errorMessage":_vm.errorMessage,"forceErrorMessage":_vm.forceErrorMessage,"showNotificationError":_vm.showNotificationError},on:{"hasError":_vm.updateHasErrorModal},model:{value:(_vm.dataModal),callback:function ($$v) {_vm.dataModal=$$v},expression:"dataModal"}})],1)]},proxy:true},{key:"modal-footer",fn:function(){return [_c('ButtonGroup',{attrs:{"items":[
				{
					id: 'saveButtonModal',
					className: 'btn--primary',
					labelText: 'Create',
					type: 'submit',
					disabled: _vm.hasError,
					btnClick: _vm.saveAction
				},
				{
					id: 'cancelButtonModal',
					className: 'btn--link',
					labelText: 'Cancel',
					btnClick: _vm.cancelAction
				}
			]}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }